"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.expireToken = exports.invalidateToken = exports.validateToken = exports.validateAccount = exports.getConfig = exports.introduceDelay = exports.isTokenInExpiryWindow = exports.getStoredAuthData = exports.setUserDetails = exports.setTokenAndExpiry = exports.getRandomDelay = exports.hasValidToken = void 0;
var constants_1 = require("../constants");
var config_1 = require("../config");
var storage_1 = require("./storage");
var formatCurrentDateToUTC = function () {
    var currentDate = new Date();
    var utcDate = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60000);
    return utcDate;
};
var validateAccount = function (accountDetails) {
    var sessionUserId = parseInt((0, storage_1.getItemFromStorage)('hiverAuthUserId') || '0');
    var sessionUserGroupId = parseInt((0, storage_1.getItemFromStorage)('hiverAuthUserGroupId') || '0');
    var userId = accountDetails.userId, usergroupId = accountDetails.usergroupId;
    return sessionUserId === userId && usergroupId === sessionUserGroupId;
};
exports.validateAccount = validateAccount;
var validateToken = function (params) {
    var isValidAccount = validateAccount(params);
    return !isTokenInExpiryWindow() && isValidAccount;
};
exports.validateToken = validateToken;
var invalidateToken = function (params) {
    if (params.apiRetry) {
        return params.apiRetry > 0;
    }
    return false;
};
exports.invalidateToken = invalidateToken;
var expireToken = function () {
    try {
        sessionStorage.removeItem('hiverAuthTokenExpiry');
    }
    catch (err) {
        console.log('Heimdall: Unable to Remove token.');
    }
};
exports.expireToken = expireToken;
var hasValidToken = function (params) {
    var tokenExpiry = (0, storage_1.getItemFromStorage)('hiverAuthTokenExpiry') || '';
    var expiryDate = new Date(tokenExpiry);
    var currentDate = formatCurrentDateToUTC();
    var isValidAccount = validateAccount(params);
    console.log('Heimdall: checking if there is a valid token', currentDate < expiryDate && isValidAccount);
    return currentDate < expiryDate && isValidAccount;
};
exports.hasValidToken = hasValidToken;
var getRandomDelay = function () {
    return Math.floor(Math.random() * 60000) + 60000;
};
exports.getRandomDelay = getRandomDelay;
var setUserDetails = function (userId, usergroupId) {
    if (!userId || !usergroupId) {
        throw new Error('User Id or user group Id not found in the response');
    }
    (0, storage_1.setItemInStorage)('hiverAuthUserId', userId);
    (0, storage_1.setItemInStorage)('hiverAuthUserGroupId', usergroupId);
};
exports.setUserDetails = setUserDetails;
var setTokenAndExpiry = function (atToken, expiryTime) {
    if (!atToken) {
        throw new Error('Token not found in the response');
    }
    (0, storage_1.setItemInStorage)('hiverAuthToken', atToken);
    (0, storage_1.setItemInStorage)('hiverAuthTokenExpiry', expiryTime);
};
exports.setTokenAndExpiry = setTokenAndExpiry;
var getStoredAuthData = function () {
    var expiryTime = (0, storage_1.getItemFromStorage)('hiverAuthTokenExpiry');
    var token = (0, storage_1.getItemFromStorage)('hiverAuthToken');
    var userId = (0, storage_1.getItemFromStorage)('hiverAuthUserId');
    var usergroupId = (0, storage_1.getItemFromStorage)('hiverAuthUserGroupId');
    return { token: token, expiryTime: expiryTime, userId: userId, usergroupId: usergroupId };
};
exports.getStoredAuthData = getStoredAuthData;
var isTokenInExpiryWindow = function () {
    var expiryTime = (0, storage_1.getItemFromStorage)('hiverAuthTokenExpiry') || '';
    if (!expiryTime) {
        return true;
    }
    var currentTime = formatCurrentDateToUTC();
    var expiry = new Date(expiryTime);
    var fourMinutesInMilliseconds = 4 * 60 * 1000;
    var isInExpiryWindow = expiry.getTime() - currentTime.getTime() < fourMinutesInMilliseconds;
    console.log({ currentTime: currentTime, expiry: expiry, isInExpiryWindow: isInExpiryWindow });
    return isInExpiryWindow;
};
exports.isTokenInExpiryWindow = isTokenInExpiryWindow;
var introduceDelay = function (delay) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, new Promise(function (resolve) { return setTimeout(resolve, delay); })];
            case 1:
                _a.sent();
                return [2];
        }
    });
}); };
exports.introduceDelay = introduceDelay;
var getConfig = function (appEnv, tier, isHiverApiDomain) {
    switch (tier) {
        case constants_1.TIERS.SIT:
            return isHiverApiDomain ? (0, config_1.getSitApiConfig)(appEnv) : (0, config_1.getSitHqConfig)(appEnv);
        case constants_1.TIERS.PROD:
            return isHiverApiDomain ? (0, config_1.getProdApiConfig)() : (0, config_1.getProdHqConfig)();
        case constants_1.TIERS.DEV:
        default:
            return isHiverApiDomain ? (0, config_1.getDevApiConfig)() : (0, config_1.getDevHqConfig)();
    }
};
exports.getConfig = getConfig;
//# sourceMappingURL=index.js.map